import React from 'react'
import './thankyou.css'
import { useNavigate } from 'react-router-dom'

const Thankyou = () => {
  const navigate=useNavigate()

  const handleHomeClick = () => {
    navigate('/')
  }
  return (
    <>
      <div className="thankyou-container">
        <div className="thankyou-card">
          <div className="thankyou-header">
            <h1>THANK YOU!</h1>
            <p>Your consultation has been booked successfully</p>
          </div>
          <div className="thankyou-content">
            <div className="thankyou-icon">
              <i className="checkmark"></i>
            </div>
            <p className="thankyou-message">We appreciate you choosing our services.</p>
            <p className="thankyou-details">We Will Contact You Soon.</p>
            <div className="thankyou-actions">
              <button className="thankyou-home-btn" onClick={handleHomeClick}>Return to Home</button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Thankyou
